<template>
    <section v-if="trustGroupData.length" class="text-center bg-fullscreen authorities">
        <h3>
            {{ title }}
        </h3>
        <div class="automation-logo flex-row justify-content-center">
            <a
                v-for="authorityItem in trustGroupData.slice(0, limit)"
                :key="authorityItem.authority.id"
                :href="authorityItem.authority.website_url"
                target="_blank"
            >
                <img
                    class="logo-auth lazyload"
                    :data-src="authorityItem.authority.image_url"
                    :alt="authorityItem.authority.name"
                />
            </a>
        </div>
    </section>
</template>

<script>
export default {
    name: 'trust-signal-groups',
    props: {
        title: {
            type: String,
            default: 'Licensing Authorities and Testing Agencies',
        },
        limit: {
            type: Number,
            default: 5,
        },
        orderBy: {
            type: String,
            default: 'order',
        },
    },
    data() {
        return {
            trustGroupData: [],
        };
    },
    mounted() {
        // Check to see if we have a cookie set
        if ($cookies.isKey('op_list_region_us')) {
            this.state = $cookies.get('op_list_region_us');
        } else {
            this.state = "nj"
        }

        this.fetchAuthorities();
    },
    methods: {
        /**
         * Get the states for the select dropdown
         */
        fetchAuthorities() {
            var self = this;
            this.loading = true;
            this.trustGroupData = [];
            var endpoint = '/us/json-files/' + this.state.toLowerCase() + '.json';
            $.ajax({
                type: 'GET',
                url: endpoint,
                success: function success(response) {
                    self.loading = false;

                    if (Array.isArray(response.trust_groups)) {
                        if (response.trust_groups[0]) {
                            self.trustGroupData = response.trust_groups[0]['trust_signal_authorities'];
                        }
                    } else if (response.trust_groups != null && typeof response.trust_groups === 'object' && 'trust_signal_authorities' in response.trust_groups) {
                        self.trustGroupData = response.trust_groups['trust_signal_authorities'];
                    }

                    self.trustGroupData.sort((a, b) => a.order - b.order);
                },
                failure: function failure(errMsg) {
                    self.loading = false;
                    console.log(errMsg);
                },
            });
        }
    },
};
</script>
